import { Component } from "react";
import Table from 'react-bootstrap/Table';

class ProportionOfCIUsersRankingTable extends Component {
    static Title = "Proportion of CI users ranking themselves better"
    render() {
        return (
            <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th></th>
                    <th colSpan="4" className="text-center">Proportion of CI users ranking themselves higher (%)</th>
                  </tr>
                </thead>              
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Hearing aid patient<br/> preoperative rating</th>
                    <th>S1Q2 (%)</th>              
                    <th>S1Q13 (%)</th>              
                    <th>S3Q10 (%)</th>              
                    <th>S3Q15 (%)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>0</td>
                    <td>99.33</td>
                    <td>92.05</td>
                    <td>97.99</td>
                    <td>93.26</td>
                  </tr>                                
                  <tr>
                    <td>1</td>
                    <td>98.43</td>
                    <td>87.73</td>
                    <td>95.08</td>
                    <td>86.28</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>97.32</td>
                    <td>79.55</td>
                    <td>91.05</td>
                    <td>77.67</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>95.3</td>
                    <td>71.36</td>
                    <td>87.25</td>
                    <td>65.35</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>93.96</td>
                    <td>62.73</td>
                    <td>80.31</td>
                    <td>55.58</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>90.38</td>
                    <td>52.73</td>
                    <td>71.59</td>
                    <td>41.86</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>84.56</td>
                    <td>44.32</td>
                    <td>62.86</td>
                    <td>33.26</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>74.05</td>
                    <td>32.95</td>
                    <td>43.62</td>
                    <td>19.53</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>53.47</td>
                    <td>22.5</td>
                    <td>23.04</td>
                    <td>9.77</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>28.64</td>
                    <td>9.55</td>
                    <td>7.16</td>
                    <td>2.09</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                    <td>0</td>
                  </tr>
                </tbody>
            </Table>
                    );
    }
}
export default ProportionOfCIUsersRankingTable 